import React from "react";
import Checkbox from "../../../components/controls/checkbox/Checkbox";

const RoleItem = (props) => {
    const { role, handleItemChange, disabled  } = props;
    const handlePermissionChange = (permissionIndex, isChecked) => {
        handleItemChange(isChecked, `${role.title}.${permissionIndex}`);
    };

    return (
        <tr>
            <td>
                {role.displayTitle}
            </td>
            <td>
                <Checkbox
                    disabled={disabled}
                    checked={role.title === 'Account' ? role.permissions.length === 2 : role.permissions.length === 4}
                    setChecked={(checked) => handlePermissionChange('All', checked)} />
            </td>
            <td>
                {role.permission.includes('View') && (
                    <Checkbox
                        disabled={disabled}
                        checked={role.permissions.includes('View')}
                        setChecked={(checked) => handlePermissionChange('View', checked)} />
                )}
            </td>
            <td>
                {role.permission.includes('Edit') && (
                    <Checkbox
                        disabled={disabled}
                        checked={role.permissions.includes('Edit')}
                        setChecked={(checked) => handlePermissionChange('Edit', checked)} />
                )}
            </td>
            <td>
                {role.permission.includes('Create') && (
                    <Checkbox
                        disabled={disabled}
                        checked={role.permissions.includes('Create')}
                        setChecked={(checked) => handlePermissionChange('Create', checked)} />
                )}
            </td>
            <td>
                {role.permission.includes('Delete') && (
                    <Checkbox
                        disabled={disabled}
                        checked={role.permissions.includes('Delete')}
                        setChecked={(checked) => handlePermissionChange('Delete', checked)} />
                )}
            </td>
        </tr>
    )
}

export default RoleItem;